import Wrapper from "../../Wrapper";

 const AceCommunications = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>ACE Communications</h3>
         </Wrapper>
         </>
     );
 }
 export default AceCommunications;